import { Box, Container, Typography, Paper, useTheme, alpha } from '@mui/material'
import LegalHero from './LegalHero'
import { motion } from 'framer-motion'

const CancellationPolicy = () => {
  const theme = useTheme()

  return (
    <Box>
      <LegalHero
        title="Cancellation Policy"
        subtitle="Understanding our booking cancellation terms and refund process"
        lastUpdated="January 15, 2024"
      />
      
      <Container
        maxWidth="lg"
        component={motion.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <Paper
          elevation={0}
          sx={{
            mt: -6,
            mb: 8,
            p: { xs: 3, md: 6 },
            borderRadius: 2,
            bgcolor: 'white',
            position: 'relative',
            zIndex: 3,
            boxShadow: `0 4px 24px ${alpha(theme.palette.common.black, 0.1)}`,
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
            Standard Cancellation Terms
          </Typography>
          <Typography paragraph>
            We understand that plans can change. Our cancellation policy is designed to be fair and transparent:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                <strong>Free Cancellation:</strong> Up to 48 hours before check-in date
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>Late Cancellation:</strong> 24-48 hours before check-in - 50% of the first night's charge
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>Very Late Cancellation:</strong> Less than 24 hours - 100% of the first night's charge
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }}>
            Festival Season Policy
          </Typography>
          <Typography paragraph>
            During Rath Yatra and other major festivals (peak season):
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                <strong>Free Cancellation:</strong> Up to 7 days before check-in
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>Late Cancellation:</strong> 3-7 days before check-in - 50% of total booking amount
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                <strong>Very Late Cancellation:</strong> Less than 3 days - 100% of total booking amount
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }}>
            Refund Process
          </Typography>
          <Typography paragraph>
            Our refund process is designed to be quick and hassle-free:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                Refunds are processed within 5-7 business days
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Refund will be made to the original payment method
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Bank charges and processing fees are non-refundable
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }}>
            Special Circumstances
          </Typography>
          <Typography paragraph>
            We understand that emergencies can happen. In case of:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                Medical emergencies (with valid documentation)
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Natural disasters or severe weather conditions
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Government-imposed travel restrictions
              </Typography>
            </li>
          </ul>
          <Typography paragraph>
            Please contact our support team for special consideration of your cancellation request.
          </Typography>

          {/* Add more sections as needed */}
        </Paper>
      </Container>
    </Box>
  )
}

export default CancellationPolicy 